import React, { useState } from 'react';
import '../UserDetailsForm.css'; // Import your CSS styling

const baseURL = process.env.BASE_URL || "";

const UserDetailsForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    DOB: '',
    gender: '',
    class: '',
    address: '',
    guardian: '',
    relation: '',
    phone: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    

    try {
      const response = await fetch(`${baseURL}/api/formrouter/visit/school`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log('Server Response:', result);
        alert('Form submitted successfully!');

        // Reset form
        setFormData({
          name: '',
          DOB: '',
          gender: '',
          class: '',
          address: '',
          guardian: '',
          relation: '',
          phone: ''
        });
      } else {
        console.error('Failed to submit form:', response);
        alert('Submission failed.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while submitting the form.');
    }
  };

  return (
    <div className="form-container">
      <h2 className="title">SCHOOL</h2>
      <form onSubmit={handleSubmit} className="user-form">
        <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
        <input type="date" name="DOB" placeholder="Date of Birth" value={formData.DOB} onChange={handleChange} required />
        <select name="gender" value={formData.gender} onChange={handleChange} required>
          <option value="">Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>
        <input type="text" name="class" placeholder="Class" value={formData.class} onChange={handleChange} required />
        <input type="text" name="address" placeholder="Address" value={formData.address} onChange={handleChange} required />
        <input type="text" name="guardian" placeholder="Guardian's Name" value={formData.guardian} onChange={handleChange} required />
        <input type="text" name="relation" placeholder="Relation" value={formData.relation} onChange={handleChange} required />
        <input type="tel" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default UserDetailsForm;
